@if (elearning) {
  <div class="elearning-detail">
    @if (elearning.pictures && elearning.pictures.length) {
      <div class="images">
        @for (image of elearning.pictures; track image) {
          <div class="image">
            <img [src]="getFile(image.name)">
          </div>
        }
      </div>
    }
    <div class="details">
      <div class="title">
        {{elearning.title}}
      </div>
      @if (elearning.clearnCategories && elearning.clearnCategories.length) {
        <div class="learn-categories">
          @for (lcat of elearning.clearnCategories; track lcat) {
            <div class="learn-category"
              [style.background-color]="lcat.color">
              &#9679;&nbsp;&nbsp;&nbsp;{{lcat.name}}
            </div>
          }
        </div>
      }
      <div class="info-not-main-block">
        @if (elearning?.organization?.name) {
          <div class="info-not-main">
            <div class="inm-label">{{'main.organization' | translate}}:</div>
            <div class="inm-text">{{elearning?.organization?.organizationType?.name}}  {{elearning?.organization?.name}}</div>
          </div>
        }
        @if (elearning?.userName) {
          <div class="info-not-main">
            <div class="inm-label">{{'main.manager' | translate}}:</div>
            <div class="inm-text">{{elearning?.userName}}</div>
          </div>
        }
      </div>
      @if (elearning.description) {
        <div class="description" [innerHTML]="elearning.description"></div>
      }
      @if (elearning.documents && elearning.documents.length) {
        <div class="documents">
          <document-uploader [uploadedFiles]="elearning.documents" [title]="'documents'" [hideUploadButton]="true"></document-uploader>
        </div>
      }
      @if (elearning.videos && elearning.videos.length) {
        <div class="video">
          <file-uploader [uploadedFiles]="elearning.videos" [title]="'videos'" [type]="'video'" [hideUploadButton]="true"></file-uploader>
        </div>
      }
      @if (questions && questions.length) {
        <div class="questions">
          <div class="message-box">
            {{'questions' | translate}}
          </div>
          @for (question of questions; track question; let i = $index) {
            <div class="question">
              <div class="q-title">{{i + 1}}. {{question.title}}</div>
              @if (question.type === 'text') {
                @if (finishElearning) {
<div class="answer-result" [ngClass]="{'green': question.isAnswerCorrect,
          'red': !question.isAnswerCorrect}">
                    @if (question.isAnswerCorrect) {
                      <mat-icon>done</mat-icon>
                    }
                    @if (!question.isAnswerCorrect) {
                      <mat-icon>close</mat-icon>
                    }
                  </div>
                }
                <mat-form-field style="width: 100%">
                  <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5" [value]="question.userAnswer ? question.userAnswer : ''"
                  (keyup)="changeText($event.target, question.id)" [disabled]="finishElearning"></textarea>
                </mat-form-field>
                @if (finishElearning && !question.isAnswerCorrect) {
                  <div class="correct-text">{{question.correctAnswer}}</div>
                }
              }
              @if (question.type === 'single') {
                @if (finishElearning) {
<div class="answer-result" [ngClass]="{'green': question.isAnswerCorrect,
          'red': !question.isAnswerCorrect}">
                    @if (question.isAnswerCorrect) {
                      <mat-icon>done</mat-icon>
                    }
                    @if (!question.isAnswerCorrect) {
                      <mat-icon>close</mat-icon>
                    }
                  </div>
                }
                <mat-radio-group class="radio-group" (change)="changeSingle($event, question.id)" [value]="question.userAnswer">
                  @for (answer of question.answers; track answer) {
                    <mat-radio-button value="{{answer.text}}"
                      [disabled]="finishElearning"
                    [ngClass]="{'correct-radio': finishElearning && answer.isCorrect}">{{answer.text}}</mat-radio-button>
                  }
                </mat-radio-group>
              }
              @if (question.type === 'multiple') {
                @if (finishElearning) {
<div class="answer-result" [ngClass]="{'green': question.isAnswerCorrect,
          'red': !question.isAnswerCorrect}">
                    @if (question.isAnswerCorrect) {
                      <mat-icon>done</mat-icon>
                    }
                    @if (!question.isAnswerCorrect) {
                      <mat-icon>close</mat-icon>
                    }
                  </div>
                }
                @for (answer of question.answers; track answer) {
                  <div [ngClass]="{'correct-checkbox': finishElearning && answer.isCorrect}">
                    <mat-checkbox value="{{answer.text}}" (change)="changeMulti($event, question.id)"
                    [disabled]="finishElearning" [checked]="answer.checked">{{answer.text}}</mat-checkbox>
                  </div>
                }
              }
            </div>
          }
        </div>
      }
    </div>
  </div>
}
